import { ZodError } from "zod";
import {
  isKeyTopicsBlock,
  isNewsletterBlock,
  isPianoBlock,
  isPostListBlock,
  isRelatedReportBlock,
  isWysiwygBlock,
  KeyTopicsBlockSchema,
  NewsletterBlockSchema,
  PianoBlockSchema,
  PostListSchema,
  RelatedReportSchema,
  SidecarBlock,
  SidecarBlockLayout,
  WysiwygBlockSchema,
} from "~/components/Sidecar/sidecar-schemas";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";

type ApiToSidecarContent = {
  preview?: boolean;
  rawBlocks: SidecarBlock[] | undefined;
};

export const apiToSidecarContent = ({
  rawBlocks,
  preview,
}: ApiToSidecarContent) => {
  const sidecarBlocks = getValueOrDefault(rawBlocks, [])
    ?.map((block) => {
      try {
        if (isKeyTopicsBlock(block)) {
          return KeyTopicsBlockSchema.parse(block);
        }
        if (isNewsletterBlock(block)) {
          return NewsletterBlockSchema.parse(block);
        }
        if (isPianoBlock(block)) {
          return PianoBlockSchema.parse(block);
        }
        if (isPostListBlock(block)) {
          return PostListSchema.parse(block);
        }
        if (isRelatedReportBlock(block)) {
          return RelatedReportSchema.parse(block);
        }
        if (isWysiwygBlock(block)) {
          return WysiwygBlockSchema.parse(block);
        }

        if (preview) {
          return {
            acfFcLayout: SidecarBlockLayout.UnknownBlock,
            block,
          } satisfies SidecarBlock;
        }
        // istanbul ignore next
        return null;
      } catch (err) {
        const error = err as ZodError;
        if (preview) {
          return {
            acfFcLayout: SidecarBlockLayout.InvalidProperties,
            blockName: block.acfFcLayout,
            error: error.format(),
          } satisfies SidecarBlock;
        }
        // istanbul ignore next
        throw err;
      }
    })
    .filter(Boolean) as SidecarBlock[];

  const keyTopicsBlock = sidecarBlocks.find((block) => isKeyTopicsBlock(block));
  const postListBlocks = sidecarBlocks.filter((block) =>
    isPostListBlock(block)
  );
  const relatedReportBlock = sidecarBlocks.find((block) =>
    isRelatedReportBlock(block)
  );
  const wysiwygBlocks = sidecarBlocks.filter((block) => isWysiwygBlock(block));

  return {
    sidecarBlocks,
    keyTopicsBlock,
    postListBlocks,
    relatedReportBlock,
    wysiwygBlocks,
  };
};
